<template>
  <div class="page-wrap">

    <!-- Delete confirmation modal -->
    <transition name="modal-fade">
      <div class="del-overlay" v-if="deleteModal.show" @click.self="deleteModal.show = false">
        <div class="del-modal">
          <div class="del-modal__icon"><i class="fa fa-trash"></i></div>
          <div class="del-modal__title">Delete Group?</div>
          <div class="del-modal__body">This action cannot be undone. The group will be permanently removed.</div>
          <div class="del-modal__actions">
            <button class="del-modal__cancel" @click="deleteModal.show = false">Cancel</button>
            <button class="del-modal__confirm" @click="confirmDelete">Delete</button>
          </div>
        </div>
      </div>
    </transition>

    <!-- Group create/edit modal -->
    <group
      v-if="ModalShow"
      v-on:closemodal="closeModal"
      :show-modal="ModalShow"
      :group="groupData"
      :is_edit="is_edit"
    ></group>

    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <div class="panel-header__icon"><i class="fa fa-layer-group"></i></div>
        <div class="panel-header__text">
          <div class="panel-header__title">Groups</div>
          <div class="panel-header__sub">Manage service groups and assignments</div>
        </div>
        <div class="panel-header__action">
          <button class="btn-add" @click="showModal">
            <i class="fa fa-plus"></i> Add Group
          </button>
        </div>
      </div>

      <!-- Loading -->
      <div class="tbl-loading" v-if="loadingData">
        <div class="tbl-loading__spinner"></div>
        <span>Loading groups…</span>
      </div>

      <!-- Table -->
      <div class="table-wrap" v-if="!loadingData && getGroupData.data.length > 0" @click="activeMenu = null">
        <table class="group-table">
          <thead>
            <tr>
              <th class="th-num">#</th>
              <th>Name</th>
              <th class="th-center">Active Services</th>
              <th>Image</th>
              <th class="th-center">Featured</th>
              <th class="th-action"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in getGroupData.data" :key="index" class="group-row">
              <td class="td-num">{{ index + 1 }}</td>
              <td class="td-name">{{ item.name }}</td>
              <td class="td-center">
                <span class="count-badge">{{ item.service_count }}</span>
              </td>
              <td>
                <div
                  class="group-thumb"
                  :style="'background-image: url(' + getGroupData.url + item.image + ')'"
                ></div>
              </td>
              <td class="td-center">
                <i class="fa fa-check bool-yes" v-if="item.is_featured"></i>
                <i class="fa fa-times bool-no" v-else></i>
              </td>
              <td class="td-action">
                <div class="dot-menu" :class="{ 'dot-menu--open': activeMenu === index }">
                  <button class="dot-menu__trigger" @click.stop="toggleMenu(index, $event)">
                    <i class="fa fa-ellipsis-v"></i>
                  </button>
                  <div
                    class="dot-menu__dropdown"
                    v-if="activeMenu === index"
                    :style="{ top: menuPos.top + 'px', right: menuPos.right + 'px' }"
                  >
                    <button class="dot-menu__item" @click="gotoGroupService(item.id); activeMenu = null">
                      <i class="fa fa-link"></i> Assign Service
                    </button>
                    <button class="dot-menu__item" @click="edit(item); activeMenu = null">
                      <i class="fa fa-pen"></i> Edit
                    </button>
                    <button class="dot-menu__item dot-menu__item--danger" @click="deleteItem(item.id)">
                      <i class="fa fa-trash"></i> Delete
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Empty state -->
      <div class="empty-state" v-if="!loadingData && getGroupData.data.length < 1">
        <i class="fa fa-layer-group empty-state__icon"></i>
        <div class="empty-state__title">No groups found</div>
        <div class="empty-state__sub">Add a new group to get started</div>
      </div>

    </div>
  </div>
</template>

<script>
import {
  FETCH_GROUP,
  DELETE_GROUP
} from "@/core/services/store/actions.type";
import group from "@/pages/backend/group/group";
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["currentUser", "getGroupData", "getBServices"])
  },
  mounted() {
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
    this.$store.dispatch(FETCH_GROUP);
    this._closeMenu = () => { this.activeMenu = null; };
    document.addEventListener("click", this._closeMenu);
  },
  beforeDestroy() {
    document.removeEventListener("click", this._closeMenu);
  },
  components: { group },
  methods: {
    toggleMenu(index, event) {
      if (this.activeMenu === index) { this.activeMenu = null; return; }
      this.activeMenu = index;
      const rect = event.currentTarget.getBoundingClientRect();
      this.menuPos = { top: rect.bottom + 4, right: window.innerWidth - rect.right };
    },
    showModal() {
      this.groupData = { id: 0, name: "", description: "", image: "", is_featured: false };
      this.ModalShow = true;
      this.is_edit = false;
    },
    closeModal() {
      this.ModalShow = false;
      this.$store.dispatch(FETCH_GROUP);
    },
    edit(item) {
      this.ModalShow = true;
      this.is_edit = true;
      this.groupData = { ...item, image1: this.getGroupData.url + item.image, image: "none" };
    },
    deleteItem(id) {
      this.activeMenu = null;
      this.deleteModal = { show: true, id };
    },
    confirmDelete() {
      const id = this.deleteModal.id;
      this.deleteModal.show = false;
      this.$store
        .dispatch(DELETE_GROUP, id)
        .then(() => {
          this.$toastr.s("Group deleted");
          this.$store.dispatch(FETCH_GROUP);
        })
        .catch(err => { this.errors = err; });
    },
    gotoGroupService(id) {
      this.$router.push({ name: "client.group.service", params: { id } });
    }
  },
  data() {
    return {
      loadingData: false,
      ModalShow: false,
      activeMenu: null,
      menuPos: { top: 0, right: 0 },
      deleteModal: { show: false, id: null },
      errors: [],
      is_edit: false,
      groupData: { id: 0, name: "", description: "", image: "", is_featured: false },
      breadCrumbs: [
        { id: 1, title: "Dashboard", route: "client.dashboard" },
        { id: 2, title: "Group List", route: "" }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
$font:   'Segoe UI', sans-serif;
$blue:   #389ad4;
$dark:   #0d1b3e;
$green:  #276749;
$border: #dde2ec;

@keyframes spin { to { transform: rotate(360deg); } }

.page-wrap {
  padding: 12px;
  font-family: $font;
}

/* ── panel card ── */
.panel-card {
  background: #fff;
  border: 1px solid $border;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

/* ── header ── */
.panel-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 24px;
  border-bottom: 1px solid $border;
  background: linear-gradient(135deg, #f8faff 0%, #f0f5ff 100%);

  &__icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: linear-gradient(135deg, $blue, #2277aa);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 18px;
    flex-shrink: 0;
  }

  &__text { flex: 1; }

  &__title { font-size: 16px; font-weight: 700; color: $dark; line-height: 1.2; }
  &__sub   { font-size: 12px; color: #7a8499; margin-top: 3px; }
  &__action { flex-shrink: 0; }
}

.btn-add {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: $blue;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 9px 18px;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  transition: background 0.15s, box-shadow 0.15s;

  &:hover { background: #2d85bb; box-shadow: 0 4px 12px rgba(56,154,212,0.3); }
}

/* ── loading ── */
.tbl-loading {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 28px 24px;
  font-size: 13px;
  color: #7a8499;

  &__spinner {
    width: 18px;
    height: 18px;
    border: 2.5px solid #c5d8f5;
    border-top-color: $blue;
    border-radius: 50%;
    animation: spin 0.7s linear infinite;
    flex-shrink: 0;
  }
}

/* ── table ── */
.table-wrap {
  overflow-x: auto;
  overflow-y: auto;
  max-height: 560px;
  padding: 0 24px 24px;
}

.group-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  color: $dark;

  th {
    position: sticky;
    top: 0;
    z-index: 1;
    padding: 10px 14px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #7a8499;
    border-bottom: 2px solid $border;
    white-space: nowrap;
    background: #fafbfd;
  }

  .th-num    { width: 44px; text-align: center; }
  .th-center { text-align: center; }
  .th-action { width: 44px; }

  td {
    padding: 11px 14px;
    border-bottom: 1px solid #f0f2f8;
    vertical-align: middle;
  }

  .group-row {
    transition: background 0.12s;
    &:hover { background: #f8fbff; }
    &:last-child td { border-bottom: none; }
  }

  .td-num    { text-align: center; color: #a0aab8; font-size: 12px; }
  .td-center { text-align: center; }
  .td-name   { font-size: 13px; }
  .td-action { text-align: right; padding-right: 12px; }
}

/* ── group thumbnail ── */
.group-thumb {
  width: 56px;
  height: 38px;
  border-radius: 8px;
  background-color: #eef2fb;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  border: 1px solid $border;
}

/* ── count badge ── */
.count-badge {
  display: inline-flex;
  padding: 3px 10px;
  background: rgba(56,154,212,0.1);
  color: $blue;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

/* ── bool icons ── */
.bool-yes { color: $green; font-size: 13px; }
.bool-no  { color: #d0d5e0; font-size: 13px; }

/* ── 3-dot menu ── */
.dot-menu {
  position: relative;
  display: inline-flex;
  justify-content: flex-end;

  &__trigger {
    width: 30px;
    height: 30px;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: #a0aab8;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s, color 0.15s;

    &:hover { background: #f0f3fa; color: $dark; }
  }

  &--open &__trigger { background: #f0f3fa; color: $dark; }

  &__dropdown {
    position: fixed;
    background: #fff;
    border: 1.5px solid $border;
    border-radius: 10px;
    box-shadow: 0 6px 20px rgba(0,0,0,0.1);
    z-index: 50;
    min-width: 150px;
    overflow: hidden;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 9px 14px;
    border: none;
    background: transparent;
    font-size: 13px;
    font-family: $font;
    color: $dark;
    cursor: pointer;
    text-align: left;
    transition: background 0.12s;

    &:hover { background: #f5f8ff; }
    i { font-size: 12px; color: #7a8499; width: 14px; }

    &--danger {
      color: #b42318;
      i { color: #b42318; }
      &:hover { background: #fff5f5; }
    }
  }
}

/* ── delete modal ── */
.del-overlay {
  position: fixed;
  inset: 0;
  background: rgba(13,27,62,0.45);
  backdrop-filter: blur(4px);
  z-index: 500;
  display: flex;
  align-items: center;
  justify-content: center;
}

.del-modal {
  background: #fff;
  border-radius: 18px;
  padding: 36px 32px 28px;
  width: 100%;
  max-width: 380px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0,0,0,0.18);

  &__icon {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: #fdecea;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 18px;
    font-size: 20px;
    color: #b42318;
  }

  &__title { font-size: 17px; font-weight: 700; color: $dark; margin-bottom: 10px; }
  &__body  { font-size: 13px; color: #7a8499; line-height: 1.6; margin-bottom: 28px; }
  &__actions { display: flex; gap: 10px; }

  &__cancel {
    flex: 1;
    height: 40px;
    background: #f0f3fa;
    color: $dark;
    border: 1.5px solid $border;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 500;
    font-family: $font;
    cursor: pointer;
    transition: background 0.15s;
    &:hover { background: #e4eaf5; }
  }

  &__confirm {
    flex: 1;
    height: 40px;
    background: #b42318;
    color: #fff;
    border: none;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 600;
    font-family: $font;
    cursor: pointer;
    transition: background 0.15s, box-shadow 0.15s;
    &:hover { background: #981d14; box-shadow: 0 4px 14px rgba(180,35,24,0.35); }
  }
}

.modal-fade-enter-active, .modal-fade-leave-active { transition: opacity 0.2s; }
.modal-fade-enter-active .del-modal, .modal-fade-leave-active .del-modal { transition: transform 0.2s, opacity 0.2s; }
.modal-fade-enter .del-modal, .modal-fade-leave-to .del-modal { transform: scale(0.94) translateY(8px); opacity: 0; }
.modal-fade-enter, .modal-fade-leave-to { opacity: 0; }

/* ── empty state ── */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 56px 24px;
  gap: 10px;

  &__icon { font-size: 38px; color: #c5d0e0; }
  &__title { font-size: 15px; font-weight: 600; color: $dark; }
  &__sub   { font-size: 13px; color: #7a8499; }
}
</style>
